<template>
    <div class="allSort">
      <nav-list :routers="routers">
        <keep-alive>
          <router-view ref="routerView"/>
        </keep-alive>
      </nav-list>
      <!-- <nav-list :routers="routersByCup" v-if="leagueType == 2">
        <keep-alive>
          <router-view ref="routerView"/>
        </keep-alive>
      </nav-list> -->
      <actionSheet v-show='actionSheetShowState' :isShow='actionSheetShowState' @selected="itemHandleBlock($event)" :options="yearList" :currentOption="currentYearIndex" @close='actionSheetShowState = false'/>
    </div>
</template>

<script>
import NavList from '@/components/NavList.vue'
import actionSheet from '@/components/ActionSheet'
import rightButton from '../components/yearButton'

export default {
  name: 'allSort',
  components: {
    NavList,
    actionSheet
  },
  created () {
    this.navBar().transChild = false
    this.navBar().rightButton = rightButton
  },
  mounted () {
    this.loadScheduleData()
  },
  destroyed () {
    this.navBar().rightButton = null
    this.navBar().title = ''
  },
  computed: {
    routers: function () {
      return [
        [this.$t('btnList.schedule'), 'football-league-schedule', { ...this.$router.params, 'yearForRoute': this.currentYear }],
        [this.$t('btnList.integral'), 'football-league-standings', { ...this.$router.params, 'yearForRoute': this.currentYear }],
        [this.$t('btnList.playerList'), 'football-league-players', { ...this.$router.params, 'yearForRoute': this.currentYear }],
        [this.$t('btnList.oddsStatistics'), 'football-league-odds-statistics', { ...this.$router.params, 'yearForRoute': this.currentYear, 'leagueTypeForRoute': this.leagueType }]
      ]
    }
  },
  data () {
    return {
      currentYear: '',
      currentYearIndex: 0,
      yearList: [],
      actionSheetShowState: false,
      leagueSubName: '',
      leagueType: 0 // 1联赛，2杯赛
    }
  },
  methods: {
    loadYearData: function () {
      this.$ft_getYearList(this.$route.params.leagueId).then(result => {
        var dataList = result.yearList
        var ret = dataList.findIndex((value, index, arr) => {
          return value === this.currentYear
        })
        this.currentYearIndex = ret > 0 ? ret : 0

        var newYearList = []
        dataList.forEach((item) => {
          let year = this.filterChinese(item)
          if (!year) { newYearList.push(item) }
        })
        this.yearList = newYearList
        if (newYearList.length > 0) {
          this.createYearButton()
        } else {
          this.navBar().rightButton = null
        }
      }).catch((error) => {
        console.log('error:', error)
      })
    },
    loadLeagueInfoData: function () {
      this.$ft_getLeagueInfo(this.$route.params.leagueId).then(result => {
        this.leagueSubName = result.leagueSubName
        this.navBar().title = this.leagueSubName
      }).catch((error) => {
        console.log('error:', error)
      })
    },
    loadScheduleData: function () {
      this.$ft_getLeagueFixture(this.$route.params.leagueId).then(result => {
        this.leagueType = result.type
        this.$refs.routerView.leagueType = this.leagueType
        this.loadYearData()
        this.loadLeagueInfoData()
        // this.$refs.routerView.fixtureData = result
      }).catch((error) => {
        console.log('error:', error)
      })
    },
    filterChinese: function (value) {
      let cnPattern = /[\u4E00-\u9FA5]/
      return cnPattern.test(value)
    },
    itemHandleBlock: function (index) {
      if (index >= this.yearList.length) return
      this.currentYearIndex = index
      this.currentYear = this.yearList[index]

      let button = this.navBar().$el.getElementsByClassName('year-text')[0]
      button.textContent = this.yearList[index]

      this.$refs.routerView.year = index > 0 ? this.currentYear : ''
    },
    handleYearButton: function () {
      this.actionSheetShowState = true
    },
    createYearButton: function () {
      let buttonDiv = this.navBar().$el.getElementsByClassName('year')[0]
      buttonDiv.addEventListener('click', (event) => {
        this.handleYearButton()
      })
      let button = this.navBar().$el.getElementsByClassName('year-text')[0]
      button.textContent = this.yearList[this.currentYearIndex]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "style"
</style>
